<template>
    <div class="collect">
        <div class="collect_head">
            <ul>
                <li v-for="(item,index) in tabsCard.tabs" :class="index == tabsCard.num ? 'active' : ''" :key="index" @click="tab(index)">
                    <span>{{ item }}</span>
                </li>
            </ul>
            <span v-if="!isEdit" @click="changeEditStatus">编辑</span>
            <div v-else class="barSty">
                <span style="margin-right: 10px;" @click="cancelEdit(false)">取消</span>
                <span @click="cancelEdit(true)">删除</span>
            </div>
        </div>
        <div class="main">
            <!-- 电影 -->
            <div v-if="tabsCard.num == 0">
               <el-checkbox-group v-model="checkList">
               <div class="itemCard" v-for="(item,index) in showData" :key='index'>
                    <div class="card">
                         <img :src="item.videoInfo.horizontalImage" alt="" @click="jumpToVideo(item.videoInfo.status, item.videoInfo.id)">
                       <span v-if="item.duration">时长&nbsp;{{item.duration | formatTime}}</span>
                       <div class="layer" v-show="isEdit">
                                    <el-checkbox :label="item.id"></el-checkbox>
                                </div>
                    </div>
                    <div class="cardDes">
                         <p>{{ item.videoInfo.videoName}}</p>
                        <p>第{{item.episode}}集</p>
                    </div>
                </div>
                </el-checkbox-group>
            </div>
            <!-- 电视剧 -->
            <div v-if="tabsCard.num == 1">
               <el-checkbox-group v-model="checkList">
               <div class="itemCard" v-for="(item,index) in showData" :key='index'>
                    <div class="card">
                        <img :src="item.videoInfo.horizontalImage" alt="" @click="jumpToVideo(item.videoInfo.status, item.videoInfo.id)">
                       <span v-if="item.duration">时长&nbsp;{{item.duration | formatTime}}</span>
                       <div class="layer" v-show="isEdit">
                                    <el-checkbox :label="item.id"></el-checkbox>
                                </div>
                    </div>
                    <div class="cardDes">
                         <p>{{ item.videoInfo.videoName}}</p>
                        <p>第{{item.episode}}集</p>
                    </div>
                </div>
                </el-checkbox-group>
            </div>
            <!-- 娱乐生活 -->
            <div v-if="tabsCard.num == 2">
               <el-checkbox-group v-model="checkList">
               <div class="itemCard" v-for="(item,index) in showData" :key='index'>
                    <div class="card">
                         <img :src="item.videoInfo.horizontalImage" alt="" @click="jumpToVideo(item.videoInfo.status, item.videoInfo.id)">
                       <span v-if="item.duration">时长&nbsp;{{item.duration | formatTime}}</span>
                       <div class="layer" v-show="isEdit">
                                    <el-checkbox :label="item.id"></el-checkbox>
                                </div>
                    </div>
                    <div class="cardDes">
                         <p>{{ item.videoInfo.videoName}}</p>
                        <p>第{{item.episode}}集</p>
                    </div>
                </div>
                </el-checkbox-group>
            </div>
            <div v-if="tabsCard.num == 3">
               <el-checkbox-group v-model="checkList">
               <div class="itemCard" v-for="(item,index) in showData" :key='index'>
                    <div class="card">
                         <img :src="item.videoInfo.horizontalImage" alt="" @click="jumpToVideo(item.videoInfo.status, item.videoInfo.id)">
                       <span v-if="item.duration">时长&nbsp;{{item.duration | formatTime}}</span>
                       <div class="layer" v-show="isEdit">
                                    <el-checkbox :label="item.id"></el-checkbox>
                                </div>
                    </div>
                    <div class="cardDes">
                         <p>{{ item.videoInfo.videoName}}</p>
                        <p>第{{item.episode}}集</p>
                    </div>
                </div>
                </el-checkbox-group>
            </div>
            <div v-show="isShowNoContent" class="no-data">
                <img src="@/assets/images/no_data.png" alt="暂无收藏记录">
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import { getToken, setToken, setUser } from '../../../utils/auth.js'
    export default {
        data() {
            return {
                tabsCard: {
                    tabs: ['电影','电视剧','娱乐生活','全部'],
                    num: 0
                },
                isShowNoContent: false,
                isEdit: false, // 是否编辑
                checkList: [], // 选择数组
                showData: [], // 电影展示数据
                showData1: [], // 电视剧
                showData2: [],  // 娱乐生活
                showData3: [],  // 全部
            }
        },
        props: {
            status: {
                type: Boolean,
                default: false
            }
        },
        filters: {
            formatTime(value) {
                if(value) {
                    let newVal = value.slice(0, 8)
                    return newVal
                }
            }
        },
        methods: {
            tab(index) {
                this.tabsCard.num = index;
                let type;
                if(index == 0) {
                    type = 1;
                } else if(index == 1) {
                    type = 3;
                } else if(index == 2) {
                    type = 2;
                } else if(index == 3) {
                    type = '';
                }
                let obj = {
                    type,
                    fn: (res) => {
                        this.showData = res; 
                    }
                };
                this.collectFn(obj); 
            },
            changeEditStatus() {
                this.isEdit = true;
            },
            cancelEdit(status) {
               if(status) {
                    // 选中删除的卡片
                    // console.log(this.checkList)
                    if (this.checkList.length === 0) {
                        return this.$message.warning('请选择要删除的数据')
                    }
                    this.delCollect()
                } else {
                    this.isEdit = false
                    this.checkList = []
                }
            },
            delCollect(){
                 this.$confirm('确定删除吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {
                        token: getToken()
                    }
                    let data = {
                        "historyIds": this.checkList.join(',')  // 观看历史的类型
                    }
                    axios({
                        method: 'delete',
                        url: '/realNet/history/delete',
                        headers: params,
                        data:data
                    }).then((res) =>{
                        //删除成功
                        this.$message({
                            showClose: true,
                            message: '删除成功',
                            type: 'success',
                            duration: 1000
                        })

                        this.isEdit = false
                        this.checkList = []
                        //刷新页面
                        this.tab(this.tabsCard.num)
                    }).catch(function (error) {
                        console.log(error);
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })      
                })
            },
             //收藏历史
            collectFn(obj){
                let params = {
                    token: getToken()
                };
                let data = {
                    type: 2,
                    categoryId: obj.type,   // 收藏历史的类型
                };
                axios({
                    method: 'get',
                    url: '/realNet/history/getHistories',
                    headers: params,
                    params: data
                })
                .then((res) =>{
                    if(res.data.result.content.length == 0) {
                        this.isShowNoContent = true;
                    } else {
                        this.isShowNoContent = false;
                    }
                    obj.fn(res.data.result.content);
                })
                .catch(function (error) {
                    console.log(error);
                });
            },
            jumpToVideo(status, id) {
                if (status === 1) {
                    this.$router.push({ path: 'tvplay-page', query: { contentId: id} })
                } else if (status === 2) {
                    this.$message.warning('此视频已下架，请观看其他视频')
                }
            }
        },
        mounted() {
            // 电影 
            let obj = {
                type: 1,
                fn: (res) => {
                    this.showData = res;
                }
            }
           this.collectFn(obj); 
        //    let obj1 = {
        //         type: 3,
        //         fn: (res) => {
        //             this.showData1 = res;
        //         }
        //     }
        //    this.collectFn(obj1); 
        //    let obj2 = {
        //         type: 5,
        //         fn: (res) => {
        //             this.showData2 = res;
        //         }
        //     }
        //    this.collectFn(obj2); 
        //    let obj3 = {
        //         type: '',
        //         fn: (res) => {
        //             this.showData3 = res;
        //         }
        //     }
        //    this.collectFn(obj3); 
        }
    }
</script>

<style lang='scss' scoped>
    .collect {
        width: 930px;

        .collect_head {
            width: 100%;
            height: 41px;
            border: 1px solid #EAECED;
            padding: 0 40px;
            margin-bottom: 30px;

            background-color: #F9F9F9;
            box-sizing: border-box;

            display: flex;
            justify-content: space-between;
            align-items: center;

            ul {
                width: 70%;
                height: 100%;
                padding: 0;

                li {
                    height: 100%;
                    padding: 0 20px;

                    display: flex;
                    align-items: center;
                    justify-content: center;
                    float: left;
                    font-size: 14px;
                    position: relative;
                    
                    span {
                        cursor: pointer;
                    }
                }
                .active {
                    font-weight: bold;

                    &::before {
                        position: absolute;
                        left: 50%;
                        margin-left: -15px;
                        bottom: -2px;
                        content: '';
                        background-color: #3BC0D0;
                        width: 35px;
                        height: 3px;
                    }
                }
            }
                    
            & > span {
                font-size: 14px;
                color: #2CB5C5;
                cursor: pointer;
            }

            .barSty {
                font-size: 14px;
                color: #2CB5C5;
                cursor: pointer;
            }
        }

        .main {
            width: 100%;

            div {
                width: 100%;

                .itemCard {
                    width: 290px;
                    height: 190px;
                    margin: 0 18px 40px 0;

                    display: inline-block;

                    .card {
                        width: 290px;
                        height: 165px;
                        margin-bottom: 10px;

                        background-color: #ccc;
                        position: relative;

                        span {
                            position: absolute;
                            right: 10px;
                            bottom: 10px;
                            padding: 2px 10px;
                            font-size: 14px;
                            color: #fff;
                            background-color: rgba(#000,.65);
                            border-radius: 12px;
                            text-align: center;
                        }
                        .layer {
                            position: absolute;
                            left: 0;
                            top: 0;
                            z-index: 10;
                            width: 100%;
                            height: 100%;
                            background-color: rgba(#000,.3);
                        }
                    }
                     .card img{
                        width: 290px;
                        height: 165px;
                        cursor: pointer;
                    }
                    .cardDes {
                        display: flex;
                        justify-content: space-between;
                        padding: 0px 6px;
                        font-size: 14px;
                    }
                }
            }
        }
        .no-data {
            text-align: center;
        }
    }
</style>
